<template>
  <section>
    <div v-if="loading" class="d-flex flex-column justify-content-center align-items-center p-5" :class="{ 'bg-gray-200': loading }">
      <CSpinner class="my-3" color="primary" />
      <div class="py-4 text-gray-600" v-if="loading">
        <slot name="contentLoading"></slot>
      </div>
    </div>
    <div v-else class="emptyList d-flex flex-column justify-content-center align-items-center" :class="colorBackground">
      <p class="roundedIcon mb-3" :class="'roundedIcon--' + icon.colorBackground" v-if="icon">
        <CIcon :name="icon.name" :class="icon.class" size="custom-size" :height="icon.height" viewBox="0 0 32 32" />
      </p>

      <h5 class="font-weight-bolder mb-2" v-if="title">{{ title }}</h5>
      <p class="text-gray-600 mb-3 font-md" v-if="subTitle">{{ subTitle }}</p>

      <CButton class="btn btn-primary py-2 px-3 mt-0" :to="linkTo" v-if="linkText">
        {{ linkText }}
      </CButton>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EmptyList',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    icon: {
      type: Object,
      default: () => {},
    },
    linkTo: {
      type: Object,
      default: () => {},
    },
    linkText: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    subTitle: {
      type: String,
      default: () => '',
    },
    colorBackground: {
      type: String,
      default: () => 'bg-gray-200',
    },
  },
}
</script>

<style lang="scss" scoped>
.emptyList {
  min-height: 285px;
}
</style>
